import Repository from '@/app/shared/infrastructure/http/Repository';

export default class ServiceOrderRepository extends Repository {
    uri = '/api/service-orders';

    async close(id: string) {
        return await this.client.put(`${this.uri}/${id}/close`, {});
    }
}
